import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useToast } from "../../context/ToastContext";
import styled from "styled-components";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import api from "../../services/api";
import { Form, Input, Button, ButtonGroup, Field } from "../common/controls";
import theme from "../../styles/theme";

const EditContainer = styled.div`
  max-width: 900px;
  margin: ${theme.space.md} auto;
  padding: 0 ${theme.space.md};
`;

const EditorContainer = styled.div`
  .ql-editor {
    min-height: 200px;
    max-height: 55vh;
    overflow-y: auto;
  }

  .ql-container {
    height: auto;
    min-height: 200px;
    font-size: ${theme.font.md};
  }
`;

const SubtopicEdit = () => {
  const { topicId, subtopicId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [subtopic, setSubtopic] = useState({ name: "", content: "" });
  const [loading, setLoading] = useState(true);

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  useEffect(() => {
    const loadSubtopic = async () => {
      try {
        const response = await api.get(`/topics/${topicId}/subtopics/${subtopicId}`);
        setSubtopic(response.data);
      } catch (error) {
        showToast(error.response?.data?.message || "Failed to load subtopic", "error");
        navigate(`/topic/${topicId}`);
      } finally {
        setLoading(false);
      }
    };

    loadSubtopic();
  }, [topicId, subtopicId, navigate, showToast]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/topics/${topicId}/subtopics/${subtopicId}`, subtopic);
      showToast("Subtopic updated successfully", "success");
      navigate(`/topic/${topicId}`);
    } catch (error) {
      showToast(error.response?.data?.message || "Failed to update subtopic", "error");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <EditContainer>
      <Form onSubmit={handleSubmit}>
        <Field>
          Subtopic name
          <Input
            type="text"
            value={subtopic.name}
            onChange={(e) => setSubtopic({ ...subtopic, name: e.target.value })}
            required
          />
        </Field>
        <EditorContainer>
          <ReactQuill
            value={subtopic.content}
            onChange={(content) => setSubtopic({ ...subtopic, content })}
            modules={modules}
            placeholder="Enter subtopic content..."
          />
        </EditorContainer>
        <ButtonGroup>
          <Button
            type="button"
            $secondary
            onClick={() => navigate(`/topic/${topicId}`)}
          >
            Cancel
          </Button>
          <Button type="submit">Save Changes</Button>
        </ButtonGroup>
      </Form>
    </EditContainer>
  );
};

export default SubtopicEdit; 